module.exports = __webpack_public_path__ + "img/fejlec_kep_egyben_768.ccdeeb8b.png";